import {
  AUTH_EVENTS,
  AUTH_EVENT_PARAM,
  SOURCE_QUERY_PARAM,
  LOCALE_QUERY_PARAM,
  ISSUER_QUERY_PARAM,
} from '@move-auth/shared';

const buildUrl = (
  { path, locale, params = {}, sourceUrl = null },
  authEvent
) => {
  const { origin: redirectOrigin } = new URL(window.location.href);

  const { origin, pathname, searchParams, hash = '' } = new URL(
    sourceUrl || window.location.href
  );

  if (searchParams.has(AUTH_EVENT_PARAM) === false) {
    searchParams.set(AUTH_EVENT_PARAM, authEvent);
  }

  const sourceUri = `${origin}${pathname}?${searchParams.toString()}${hash}`;
  const sourceParam = `${SOURCE_QUERY_PARAM}=${encodeURIComponent(sourceUri)}`;

  const issuerParams = Object.entries(params)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join('&');
  const issuerParam = issuerParams.length
    ? `&${ISSUER_QUERY_PARAM}=${encodeURIComponent(issuerParams)}`
    : '';

  const localeParam = locale
    ? `&${LOCALE_QUERY_PARAM}=${encodeURIComponent(locale)}`
    : '';

  return `${redirectOrigin}${path}?${sourceParam}${localeParam}${issuerParam}`;
};

export const buildLoginUrl = ({ path, locale, params, sourceUrl }) =>
  buildUrl({ path, locale, params, sourceUrl }, AUTH_EVENTS.USER_LOGIN);

export const buildRegisterUrl = ({ path, locale, params, sourceUrl }) =>
  buildUrl({ path, locale, params, sourceUrl }, AUTH_EVENTS.USER_REGISTRATION);
